/* eslint-disable no-nested-ternary */
/* eslint-disable react/function-component-definition */
import React from 'react'
import { Select } from 'antd'
import { useSales } from '../../pages/Sales/useSales'
import { Loading } from '../Loading/Loading'

// const [empresas, setEmpresas] = useState('')

// const OPTIONS = ['Apples', 'Nails', 'Bananas', 'Helicopters']

interface SelectCompanieProps {
  array: any[] // array de objetos a serem mapeados
  // nome: string
  handle: any
  value: string[] | string
  width?: boolean
}

const SelectCompanie: React.FC<SelectCompanieProps> = ({
  array,
  value,
  handle,
  width,
}) => {
  const { isLoading } = useSales()
  return isLoading ? (
    <Loading contrast={false} />
  ) : (
    <Select
      mode="multiple"
      placeholder="Pesquise uma palavra chave"
      value={value}
      onChange={handle}
      style={width ? { width: '100%' } : { width: '70%' }}
      options={
        isLoading
          ? []
          : array.map(item => ({
              value: item.nome,
              label: item.nome,
              id: item.id,
            }))
      }
    />
  )
}

export default SelectCompanie
